import { useDonationFormContext } from './DonationFormProvider'

const PURCHASE_REPLACEMENTS: [RegExp, string][] = [
  [/\bDonate by Credit Card\b/g, 'Pay by Credit Card'],
  [/\bDonate by Card\b/g, 'Pay by Card'],
  [/\bDonate by Direct Debit\b/g, 'Pay by Direct Debit'],
  [/\bDonating\b/g, 'Purchasing'],
  [/\bDonate\b/g, 'Purchase'],
  [/\bDonation\b/g, 'Purchase'],
  [/\bdonation\b/g, 'purchase'],
]

export const toPurchaseCopy = (text: string, isPurchase = false) => {
  if (!isPurchase) {
    return text
  }

  return PURCHASE_REPLACEMENTS.reduce((next, [pattern, replacement]) => next.replace(pattern, replacement), text)
}

export const usePurchaseCopy = () => {
  const isPurchase = useDonationFormContext((state) => state.settings.styles?.options?.usePurchaseWording === true)

  return (text: string) => toPurchaseCopy(text, isPurchase)
}
